import {
  Agreement,
  FranchiseType,
  Company,
  ConciliationDetail,
  ConciliationHeader,
  Country,
  HttpRequestError,
  Management,
  MasterImportExecutionForm,
  MastersImport,
  FiscalDetail,
  ConciliationHeaderState,
  ConciliationDetailErrors,
  PodOptionType,
  PosType,
  Region,
  RegionalManagement,
  Stores,
  Supervision,
  ConciliationHeaderId,
  ConcHeaderStateCount,
  ConcDetErrorCount,
  ConcHeaderFilterByState,
  ConcDetailFilterByError,
} from '../../types';

import {
  ActionType,
  ChangeConciliationHeaderIdAction,
  ChangeClosingFilterConciliationHeaderStateAction,
  ChangeClosingFilterConciliationDetailErrorsAction,
  ChangeFilterFederativeEntitiesAction,
  ChangeFilterCountryAction,
  ChangeFilterEndAccountingDateAction,
  ChangeFilterEndBusinessDateAction,
  ChangeFilterEndOperationDateAction,
  ChangeFilterPosAction,
  ChangeFilterSegmentsAction,
  ChangeFilterStartAccountingDateAction,
  ChangeFilterStartBusinessDateAction,
  ChangeFilterStartOperationDateAction,
  ChangeFilterStoreAction,
  ChangeConciliationDetailFilterStoreAction,
  ChangeConciliationDetailFilterStartAccountingDateAction,
  ChangeConciliationDetailFilterEndAccountingDateAction,
  ChangeFilterStoreMotherChildAction,
  ChangeMastersImportFilterCountryAction,
  ChangeMastersImportFilterEndImportDateAction,
  ChangeMastersImportFilterStartImportDateAction,
  ChangeMastersImportFilterStateAction,
  ChangeOpStrucuresFilterAgreementAction,
  ChangeOpStrucuresFilterCompanyAction,
  ChangeOpStrucuresFilterManagementAction,
  ChangeOpStrucuresFilterRegionAction,
  ChangeOpStrucuresFilterRegionalManagementAction,
  ChangeOpStrucuresFilterSupervisionAction,
  FindConciliationDetailRequestedAction,
  FindConciliationDetailSuccessAction,
  FindConciliationDetailFailureAction,
  FindConciliationHeaderRequestedAction,
  FindConciliationHeaderSuccessAction,
  FindConciliationHeaderFailureAction,
  FindMastersImportFailureAction,
  FindMastersImportRequestedAction,
  FindMastersImportSuccessAction,
  FindMastersTypesFailureAction,
  FindMastersTypesRequestedAction,
  FindMastersTypesSuccessAction,
  FindFiscalDetailRequestedAction,
  FindFiscalDetailSuccessAction,
  FindFiscalDetailFailureAction,
  ChangeFiscalDetailFilterCountryAction,
  ChangeFiscalDetailFilterEndDateAction,
  ChangeFiscalDetailFilterStartDateAction,
  ChangeConciliationHeaderFilterByStateFilterAction,
  ChangeConciliationDetailFilterByErrorFilterAction,
  FindPosFailureAction,
  FindPosRequestedAction,
  FindPosSuccessAction,
  MastersImportExecutionFailureAction,
  MastersImportExecutionRequestedAction,
  MastersImportExecutionSuccessAction,
  ChangeFranchiseTypeFilterAction,
  ChangeFiscalDetailFilterStoreAction,
} from './types';

export const changeFilterCountry = (countryCode: string): ChangeFilterCountryAction => ({
  type: ActionType.changeFiltersCountry,
  countryCode,
});

export const changeFilterStoreMotherChild = (
  pod: PodOptionType[]
): ChangeFilterStoreMotherChildAction => ({
  type: ActionType.changeFiltersStoreMotherChild,
  pod,
});

export const changeFilterStore = (stores: Stores[]): ChangeFilterStoreAction => ({
  type: ActionType.changeFiltersStore,
  stores,
});

export const changeConciliationDetailFilterStore = (
  stores: Stores[]
): ChangeConciliationDetailFilterStoreAction => ({
  type: ActionType.changeConciliationDetailFiltersStore,
  stores,
});

export const changeConciliationDetailFilterStartAccountingDate = (
  date: Date | null
): ChangeConciliationDetailFilterStartAccountingDateAction => ({
  type: ActionType.changeConciliationDetailFilterStartAccountingDate,
  date,
});

export const changeConciliationDetailFilterEndAccountingDate = (
  date: Date | null
): ChangeConciliationDetailFilterEndAccountingDateAction => ({
  type: ActionType.changeConciliationDetailFilterEndAccountingDate,
  date,
});

export const changeFilterPos = (pos: string[]): ChangeFilterPosAction => ({
  type: ActionType.changeFiltersPos,
  pos,
});

export const changeFilterSegments = (segments: PosType[]): ChangeFilterSegmentsAction => ({
  type: ActionType.changeFiltersSegments,
  segments,
});

export const changeFilterStartBusinessDate = (
  date: Date | null
): ChangeFilterStartBusinessDateAction => ({
  type: ActionType.changeFilterStartBusinessDate,
  date,
});

export const changeFilterEndBusinessDate = (
  date: Date | null
): ChangeFilterEndBusinessDateAction => ({
  type: ActionType.changeFilterEndBusinessDate,
  date,
});

export const changeFilterStartOperationDate = (
  date: Date | null
): ChangeFilterStartOperationDateAction => ({
  type: ActionType.changeFilterStartOperationDate,
  date,
});

export const changeFilterEndOperationDate = (
  date: Date | null
): ChangeFilterEndOperationDateAction => ({
  type: ActionType.changeFilterEndOperationDate,
  date,
});

export const changeFilterStartAccountingDate = (
  date: Date | null
): ChangeFilterStartAccountingDateAction => ({
  type: ActionType.changeFilterStartAccountingDate,
  date,
});

export const changeFilterEndAccountingDate = (
  date: Date | null
): ChangeFilterEndAccountingDateAction => ({
  type: ActionType.changeFilterEndAccountingDate,
  date,
});

export const findPosRequested = (): FindPosRequestedAction => ({
  type: ActionType.findPosRequested,
});

export const findPosSuccess = (posOptions: string[]): FindPosSuccessAction => ({
  type: ActionType.findPosSuccess,
  posOptions,
});

export const findPosFailure = (error: HttpRequestError): FindPosFailureAction => ({
  type: ActionType.findPosFailure,
  error,
});

export const findConciliationDetailRequested = (
  sendToOndrive?: boolean
): FindConciliationDetailRequestedAction => ({
  type: ActionType.findConciliationDetailRequested,
  sendToOndrive: Boolean(sendToOndrive),
});

export const findConciliationDetailSuccess = (
  conciliationDetail: ConciliationDetail[],
  errorsCounts: ConcDetErrorCount
): FindConciliationDetailSuccessAction => ({
  type: ActionType.findConciliationDetailSuccess,
  conciliationDetail,
  errorsCounts,
});

export const findConciliationDetailFailure = (
  error: HttpRequestError
): FindConciliationDetailFailureAction => ({
  type: ActionType.findConciliationDetailFailure,
  error,
});

export const changeConciliationDetailFilterByErrorFilterAction = (
  filterByError: string
): ChangeConciliationDetailFilterByErrorFilterAction => ({
  type: ActionType.changeConciliationDetailFilterByErrorFilter,
  filterByError,
});

export const findConciliationHeaderRequested = (
  sendToOndrive?: boolean
): FindConciliationHeaderRequestedAction => ({
  type: ActionType.findConciliationHeaderRequested,
  sendToOndrive: Boolean(sendToOndrive),
});

export const findConciliationHeaderSuccess = (
  conciliationHeader: ConciliationHeader[],
  statesCounts: ConcHeaderStateCount
): FindConciliationHeaderSuccessAction => ({
  type: ActionType.findConciliationHeaderSuccess,
  conciliationHeader,
  statesCounts,
});

export const findConciliationHeaderFailure = (
  error: HttpRequestError
): FindConciliationHeaderFailureAction => ({
  type: ActionType.findConciliationHeaderFailure,
  error,
});

export const changeConciliationHeaderFilterByStateFilterAction = (
  filterByState: string
): ChangeConciliationHeaderFilterByStateFilterAction => ({
  type: ActionType.changeConciliationHeaderFilterByStateFilter,
  filterByState,
});

export const changeOpStrucuresFilterAgreement = (
  agreement: Agreement[]
): ChangeOpStrucuresFilterAgreementAction => ({
  type: ActionType.changeOpStrucuresFilterAgreement,
  agreement,
});

export const changeOpStrucuresFilterRegionalManagement = (
  regionalMgmt: RegionalManagement[]
): ChangeOpStrucuresFilterRegionalManagementAction => ({
  type: ActionType.changeOpStrucuresFilterRegionalManagement,
  regionalMgmt,
});

export const changeOpStrucuresFilterRegion = (
  region: Region[]
): ChangeOpStrucuresFilterRegionAction => ({
  type: ActionType.changeOpStrucuresFilterRegion,
  region,
});

export const changeOpStrucuresFilterManagement = (
  management: Management[]
): ChangeOpStrucuresFilterManagementAction => ({
  type: ActionType.changeOpStrucuresFilterManagement,
  management,
});

export const changeOpStrucuresFilterSupervision = (
  supervision: Supervision[]
): ChangeOpStrucuresFilterSupervisionAction => ({
  type: ActionType.changeOpStrucuresFilterSupervision,
  supervision,
});

export const changeOpStrucuresFilterCompany = (
  company: Company[]
): ChangeOpStrucuresFilterCompanyAction => ({
  type: ActionType.changeOpStrucuresFilterCompany,
  company,
});

export const changeMastersImportFilterCountry = (
  countries: Country[]
): ChangeMastersImportFilterCountryAction => ({
  type: ActionType.changeMasterImportFilterCountry,
  countries,
});

export const changeMastersImportFilterStartImportDate = (
  date: Date | null
): ChangeMastersImportFilterStartImportDateAction => ({
  type: ActionType.changeMasterImportFilterStartImportDate,
  date,
});

export const changeMastersImportFilterEndImportDate = (
  date: Date | null
): ChangeMastersImportFilterEndImportDateAction => ({
  type: ActionType.changeMasterImportFilterEndImportDate,
  date,
});

export const changeMastersImportFilterState = (
  state: string[]
): ChangeMastersImportFilterStateAction => ({
  type: ActionType.changeMasterImportFilterState,
  state,
});

export const changeConciliationHeaderId = (
  conciliationHeaderId: ConciliationHeaderId
): ChangeConciliationHeaderIdAction => ({
  type: ActionType.changeConciliationHeaderId,
  conciliationHeaderId,
});

export const changeClosingFilterConciliationHeaderState = (
  causeTypes: ConciliationHeaderState[]
): ChangeClosingFilterConciliationHeaderStateAction => ({
  type: ActionType.changeFilterConciliationHeaderState,
  causeTypes,
});

export const changeClosingFilterConciliationDetailErrors = (
  causeTypes: ConciliationDetailErrors[]
): ChangeClosingFilterConciliationDetailErrorsAction => ({
  type: ActionType.changeFilterConciliationDetailErrors,
  causeTypes,
});

export const changeFilterFederativeEntities = (
  federativeEntities: string[]
): ChangeFilterFederativeEntitiesAction => ({
  type: ActionType.changeFilterFederativeEntities,
  federativeEntities,
});

export const changeFranchiseTypeFilter = (
  franchiseTypes: FranchiseType[]
): ChangeFranchiseTypeFilterAction => ({
  type: ActionType.changeFranchiseTypeFilter,
  franchiseTypes,
});

export const findMastersImportRequested = (): FindMastersImportRequestedAction => ({
  type: ActionType.findMastersImportRequested,
});

export const findMastersImportSuccess = (
  mastersImport: MastersImport[]
): FindMastersImportSuccessAction => ({
  type: ActionType.findMastersImportSuccess,
  mastersImport,
});

export const findMastersImportFailure = (
  error: HttpRequestError
): FindMastersImportFailureAction => ({
  type: ActionType.findMastersImportFailure,
  error,
});

export const findMastersTypesRequested = (): FindMastersTypesRequestedAction => ({
  type: ActionType.findMastersTypesRequested,
});

export const findMastersTypesSuccess = (mastersTypes: string[]): FindMastersTypesSuccessAction => ({
  type: ActionType.findMastersTypesSuccess,
  mastersTypes,
});

export const findMastersTypesFailure = (
  error: HttpRequestError
): FindMastersTypesFailureAction => ({
  type: ActionType.findMastersTypesFailure,
  error,
});

export const mastersImportExecutionRequested = (
  payload: MasterImportExecutionForm
): MastersImportExecutionRequestedAction => ({
  type: ActionType.mastersImportExecutionRequested,
  payload,
});

export const mastersImportExecutionSuccess = (): MastersImportExecutionSuccessAction => ({
  type: ActionType.mastersImportExecutionSuccess,
});

export const mastersImportExecutionFailure = (
  error: HttpRequestError
): MastersImportExecutionFailureAction => ({
  type: ActionType.mastersImportExecutionFailure,
  error,
});

export const findFiscalDetailRequested = (): FindFiscalDetailRequestedAction => ({
  type: ActionType.findFiscalDetailRequested,
});

export const findFiscalDetailSuccess = (
  fiscalDetail: FiscalDetail[]
): FindFiscalDetailSuccessAction => ({
  type: ActionType.findFiscalDetailSuccess,
  fiscalDetail,
});

export const findFiscalDetailFailure = (
  error: HttpRequestError
): FindFiscalDetailFailureAction => ({
  type: ActionType.findFiscalDetailFailure,
  error,
});

export const changeFiscalDetailFilterCountry = (
  countries: Country[]
): ChangeFiscalDetailFilterCountryAction => ({
  type: ActionType.changeFiscalDetailFilterCountry,
  countries,
});

export const changeFiscalDetailFilterStartDate = (
  date: Date | null
): ChangeFiscalDetailFilterStartDateAction => ({
  type: ActionType.changeFiscalDetailFilterStartDate,
  date,
});

export const changeFiscalDetailFilterEndDate = (
  date: Date | null
): ChangeFiscalDetailFilterEndDateAction => ({
  type: ActionType.changeFiscalDetailFilterEndDate,
  date,
});

export const changeFiscalDetailFilterStore = (
  stores: Stores[]
): ChangeFiscalDetailFilterStoreAction => ({
  type: ActionType.changeFiscalDetailFilterStore,
  stores,
});
